import './GameButton.css';
import React from 'react';

export const GameButton = ({
  variant,
  children,
  onClick,
  size,
  disable,
}: {
  variant: number;
  children: React.ReactNode;
  onClick?: () => void;
  size?: 'lg' | 'sm' | 'md';
  disable?: boolean;
}) => {
  return (
    <div
      key={size}
      className={`game_button-root game_button-size_${size ?? 'sm'} game_button-${variant} ${
        disable === true ? 'game_button-root_disabled' : ''
      }`}
      onClick={disable === true ? undefined : onClick}
    >
      {children}
    </div>
  );
};
